export const IotEventsWrapper = () => {
    const url = 'https://iot-data-quality-monitor.asset-history.rio.cloud/';
    return (
        <div className='iframe-wrapper height-100pct' style={{ position: 'unset' }}>
            <iframe title='data-quality-iframe' className='unstyled bg-lighter full-window' src={url} />
        </div>
    );
};
